<template>
  <div class="home">
    <!--header start-->
    <div class="header index-header home-header">
        <!--router-link class="icon-menu home-icon" to="/find" tag="a"></router-link-->
      <div class="nav">
        <a href="javascript:void(0);" v-for="(item,ind) in channel" @click="fnTable(item.id)"
           :class="navOn == item.id?'id-nav-recom nav-on':'id-nav-recom'">
          {{item.slug}}
        </a>
      </div>
    </div>

  
    <!--header end-->

    <!--content start-->
    <router-view style="margin-bottom: 5px"></router-view>
    <!--content end-->

    <!-- nav-bottom -->
    <div class="nav-bottom">
      <router-link class="nav-on" to="/home">
        <i class="icon-index"></i>
        发现
      </router-link>
      <!--router-link class="icon-title" to="/discovery">
        <i class="icon-find"></i>
        发现
      </router-link-->
      <router-link class="icon-title" to="/mymessage">
        <i class="icon-mine"></i>
        我的
      </router-link>
    </div>

    <!--遮罩-->
    <div class="overplay" style="display:none"></div>

    <!-- 返回顶部按钮 -->
    <div v-show="upward" class="back-top"  @click="returnTop">
      返回顶部
    </div>

    <!--所有央视频道-->
    <!--
    <div class="allchannel" v-show="allChannelsShow">
      <div class="allHeader">
        <h3>全部频道</h3>
        <span @click="allChannelsShow = false">取消</span>
      </div>
      <div class="allconten">
        <div>
          <dl v-for="item in allchannel" @click="fnTable(item.id)">
            <dt><img :src="item.pic_h5" alt=""/></dt>
            <dd>{{item.channelName}}</dd>
          </dl>
        </div>
      </div>
    </div>
    -->
  </div>
</template>

<script>
export default {
  data (){
    return {
      navOn: 'index',    //导航选中
      channel: '', //导航渲染
      allchannel: '',
      allChannelsShow: false,
      globalUrl: API.GlobalUrl,
      upward: false
    }
  },
  methods: {
    //操作按钮事件
    fnTable(id) {   //切换头部按钮
      this.navOn = id;
      if (id == 'index') {
        this.$router.push({name: 'HomeIndex'})
      } else {
        this.$router.push({name: 'HomeChannel', params: {id: id}});
        if (this.allChannelsShow === true) {
          this.allChannelsShow = false
        }
      }
    },
    menu() {  //是否显示回到顶部按钮
      if (document.body.scrollTop > 800) {
        this.upward = true;
      } else {
        this.upward = false;
      }
    },
    returnTop(){ //返回顶部
      $('html,body').stop().animate({scrollTop: '0px'}, 500);
    }
  },
  created: function () {
    //ajax请求
    // var id = this.$route.params.id;
    // console.log(id);
    // if(typeof id === 'undefined' || id==='index'){
      this.$router.push('/');
    // }
    // else {
    //   this.navOn = id;
    //   this.$router.push('/channel/' + id);
    // }
    
    $(document).unbind("scroll");
    var that = this;
    //判断pc移动
    if (that.IsPC()) {
      window.location.href = API.IsPcName
    }

      that.channel = [
{
id: "index",
slug: "发现"
}];
    //所有央视频道
    // this.$http.get(API.GetChannelList)
    //   .then(function (res) {
    //   if (res.code == '0') {
    //     that.allchannel = res.data;
    //   }
    // });
    // // //table央视频道
    // this.$http.get(API.GetHomeChannel)
    //   .then(function (res) {
    //   // console.log(res)
    //   if (res.code == '0') {
    //     that.channel = res.data;
    //   }
    // });

  },
  mounted: function () {
    //操作DOM
  }

}
</script>

<style>
  .home-header {
    overflow: hidden;
  }

  .index-header .nav {
    left: 0;
    height: 100%;
    line-height: 40px;
  }

  .allchannel {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    overflow-y: auto;
  }

  .allHeader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    height: 43px;
    line-height: 43px;
    text-align: center;
    border-bottom: 1px solid #d3d3d3;
  }

  .allHeader h3 {
    font-size: 16px;;
  }

  .allHeader span {
    position: absolute;
    font-size: 14px;
    right: 14px;
    top: 0;
    color: #666666;
  }

  .allconten {
    padding-top: 40px;;
  }

  .allconten dl {
    float: left;
    width: 33.3%;
    margin: 27px 0 0 0;
    text-align: center;
  }

  .allconten dt {
    display: inline-block;
    height: 70px;
    width: 70px;;
    line-height: 70px;
    text-align: center;
  }

  .allconten dt img {
    width: 100%;
    height: auto;
    display: inline-block;
  }

  .allchannel dd {
    font-size: 14px;;
    margin: 0;
  }

  .home-icon {
    float: right;
    margin-top: 2px
  }

  .nav-bottom {
    box-shadow: 0 1px 8px #888888;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue